import { OverLayFields } from '../models/OverlayFields';
import { PositioningType } from '../models/PositioningType';

export const ESPPositioning: PositioningType[] = [
  {
    overlayField: OverLayFields.LastGoodScan,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.LastCardTime,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.LastSetPointScanTime,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.APIDesignation,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CurrentCommunicationStatus,
    position: { x: 0, y: 140 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ControllerType,
    position: { x: 193, y: 300 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RTUAddress,
    position: { x: 193, y: 255 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TimeInState,
    position: { x: 147, y: 134 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TubingPressure,
    position: { x: 620, y: 473 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CasingPressure,
    position: { x: 620, y: 517.13 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.FlowlinePressure,
    position: { x: 620, y: 560.25 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.DownwholeSensorData,
    position: { x: 620, y: 650.38 },
    smallPosition: { x: 350, y: 714.38 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.FluidLevel,
    position: { x: 651, y: 603.38 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ESPEquipment,
    position: { x: 100, y: 490 },
    smallPosition: { x: 76, y: 544 },
    justification: 'left',
  },
];
